import HotspotBank from './HotspotBank';

export default HotspotBank;
